export default __webpack_public_path__ + "static/media/logo.c7830650.png";